import React from 'react';
import ShippingStatus from './ShippingStatus';
import OrderStatus from './OrderStatus';
import AuditReport from './AuditReport';

export default props => (
  <ul className="list-group mb-4">
    <li className="list-group-item">
      <strong>Order Status:</strong> <OrderStatus status={props.order.status} />
    </li>
    <li className="list-group-item">
      <strong>Property:</strong> {props.order.property}
    </li>
    <li className="list-group-item">
      <strong>Borrower:</strong> {props.order.borrower}
    </li>
    {!!props.order.auditReport && (
      <li className="list-group-item">
        <p className="mb-2">
          <strong>Audit Report:</strong>
        </p>
        <AuditReport auditReport={props.order.auditReport} />
      </li>
    )}
    <li className="list-group-item">
      <strong>Incoming Shipment:</strong>{' '}
      <a href={props.order.incomingTrackingUrl} target="_blank">
        {props.order.incomingTrackingNumber}
      </a>{' '}
      <ShippingStatus status={props.order.incomingStatus} />
    </li>
    {props.order.outgoingTrackingUrl && (
      <li className="list-group-item">
        <strong>Outgoing Shipment:</strong>{' '}
        <a href={props.order.outgoingTrackingUrl} target="_blank">
          {props.order.outgoingTrackingNumber}
        </a>{' '}
        <ShippingStatus status={props.order.outgoingStatus} />
      </li>
    )}
  </ul>
);



// WEBPACK FOOTER //
// ./src/components/orders/OrderDetailList.js